<template>
  <b-container class="my-5">
    <b-row>
      <b-col xl="12">
        <b-card no-body>
          <b-card-body class="bg-light">
            <b-form @submit="submit">
              <b-form-row>
                <b-col md="5">
                  <b-form-input
                    id="address"
                    v-model="form.data.address"
                    type="text"
                    required
                    size="lg"
                    :placeholder="$t('doctors.labels.address')" />
                </b-col>
                <b-col md="4">
                  <b-form-select
                    id="speciality"
                    v-model="form.data.speciality"
                    :options="form.metadata.specialities"
                    size="lg"
                    required>
                    <template v-slot:first>
                      <option :value="null" disabled>{{ $t('doctors.labels.speciality') }}</option>
                    </template>
                  </b-form-select>
                </b-col>
                <b-col md="2">
                  <b-form-select
                    id="distance"
                    v-model="form.data.distance"
                    :options="form.metadata.distances"
                    size="lg"
                    required />
                </b-col>
                <b-col md="1">
                  <b-button block variant="primary" type="submit" size="lg">
                    <font-awesome-icon :icon="['fas','search']"/>
                  </b-button>
                </b-col>
              </b-form-row>
            </b-form>
          </b-card-body>
        </b-card>
        <b-tabs class="mt-5" content-class="pt-3">
          <b-tab title="Lista" active>
            <b-card no-body class="mb-3" v-for="office in offices.docs" v-bind:key="office.id">
              <b-row no-gutters>
                <b-col md="2">
                  <b-card-img :src="office.medic.avatar.secure_url" left height="120" width="120" />
                </b-col>
                <b-col md="10">
                  <b-row>
                    <b-col md="12">
                      <b-card-title class="text-primary"><b-link target="_blank" :href="'/doctors/' + office.medic._id + '?office=' + office._id">{{ office.medic.fullName }}</b-link></b-card-title>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4">
                      <font-awesome-icon class="text-success" :icon="['fas', 'envelope']"/>
                      {{ office.email }}
                    </b-col>
                    <b-col md="4" class="text-truncate">
                      <font-awesome-icon class="text-success" :icon="['fas', 'phone']"/>
                      {{ office.phone }}
                    </b-col>
                    <b-col md="4">
                      <font-awesome-icon class="text-success" :icon="['fas', 'street-view']"/>
                      {{ office.dist.calculated | fixNumber(2) }} metros
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <font-awesome-icon class="text-success" :icon="['fas', 'map-marker-alt']"/>
                      {{ office.fullAddress }}
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
            <div>
              <b-pagination
                class="justify-content-center"
                v-model="offices.page"
                :total-rows="offices.total"
                :per-page="offices.perPage"
                @input="nextPage" />
            </div>
          </b-tab>
          <b-tab title="Mapa" @click="onShowMap">
            <div id="map" style='height: 600px;'></div>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col xl="12">
        <adsense
          ad-slot="9585150092"
          ad-format="auto"
          :ad-client="adsenseClient"
          ad-style="display:block">
        </adsense>
      </b-col>
    </b-row>
    <div class="vld-parent">
      <loading :active.sync="loading"
      :can-cancel=false
      :is-full-page="fullPage" />
    </div>
  </b-container>
</template>

<script>
import Adsense from '@/components/Adsense'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: { Adsense, Loading },
  name: 'Doctors',
  data () {
    return {
      loading: false,
      fullPage: true,
      imageMarker: 'https://s3.amazonaws.com/listadomedico/images/map-marker39.png',
      adsenseClient: process.env.VUE_APP_GOOGLE_ADSENSE_CLIENT,
      markers: [],
      autocomplete: null,
      locationMarker: null,
      map: {
        object: null,
        lat: null,
        lng: null
      },
      form: {
        data: {
          address: null,
          latitude: null,
          longitude: null,
          distance: 3,
          speciality: null
        },
        metadata: {
          distances: [],
          specialities: []
        }
      },
      offices: {
        docs: [],
        total: 0,
        perPage: 10,
        page: 1
      }
    }
  },
  metaInfo () {
    return {
      titleTemplate: `%s | ${this.$i18n.t('find_doctors')}`
    }
  },
  mounted: async function () {
    const catalogs = await this.$http.get('/catalogs')
    this.form.metadata.specialities = catalogs.data.specialities
    this.form.metadata.distances = catalogs.data.distances

    const options = { types: ['geocode'] }
    this.autocomplete = new window.google.maps.places
      .Autocomplete(document.getElementById('address'), options)
    this.autocomplete.addListener('place_changed', this.onPlaceChanged)

    if (this.$route.query && this.$route.query.latitude && this.$route.query.longitude) {
      this.form.data.latitude = this.$route.query.latitude
      this.form.data.longitude = this.$route.query.longitude
      this.form.data.distance = this.$route.query.distance
      this.form.data.speciality = this.$route.query.speciality
      this.form.data.address = this.$route.query.address
      await this.submit()
    }
  },
  methods: {
    onPlaceChanged () {
      const place = this.autocomplete.getPlace()
      this.form.data.address = place.formatted_address
      this.form.data.latitude = place.geometry.location.lat()
      this.form.data.longitude = place.geometry.location.lng()
    },
    onShowMap () {
      const geolocation = {}
      if (!this.map.object && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          geolocation.lat = position.coords.latitude
          geolocation.lng = position.coords.longitude

          const uluru = { lat: geolocation.lat, lng: geolocation.lng }
          this.map.object = new window.google.maps
            .Map(document.getElementById('map'), { center: uluru, zoom: 14 })

          this.locationMarker = new window.google.maps
            .Marker({ position: uluru, map: this.map.object, title: 'Mi ubicación' })
          this.map.lat = geolocation.lat
          this.map.lng = geolocation.lng
          this.setMarkers()
        }.bind(this))
      } else if (this.map.object) {
        this.setMarkers()
      }
    },
    async submit (event) {
      if (event) event.preventDefault()
      this.form.data.page = this.offices.page
      this.loading = true
      try {
        const result = await this.$http.get('/doctors', { params: this.form.data })
        this.offices.docs = result.data.docs
        this.offices.total = result.data.total
        this.offices.page = result.data.page
      } catch (error) {
        const { errors } = error.response.data
        errors.forEach(function (error) {
          this.$bvToast.toast(error.message, {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
        }.bind(this))
      }
      this.loading = false
    },
    onResetDoctorSearch () {

    },
    fetch () {

    },
    async nextPage (page) {
      this.offices.page = page
      await this.submit()
    },
    setMarkers () {
      const map = this.map.object
      this.markers.forEach(marker => marker.setMap(null))
      this.markers = []

      this.offices.docs.forEach(function (office) {
        const contentString = '<h5>Médico ' + office.medic.fullName + '</h5>' +
          '<p><b>Dirección:</b> ' + office.fullAddress + '</p>' +
          '<p><b>Teléfono:</b> ' + office.phone + '</p>' +
          '<p><b>Email:</b> ' + office.email + '</p>' +
          '<p><a href="https://listadomedico.com/doctors/' + office.medic._id +
          '?office=' + office._id + '" target="_blank">Ver perfil completo</a></p>'

        const infowindow = new window.google.maps
          .InfoWindow({ content: contentString })

        const coordinates = {
          lat: office.dist.location.coordinates[1],
          lng: office.dist.location.coordinates[0]
        }

        const marker = new window.google.maps.Marker({
          position: coordinates,
          map: map,
          title: office.medic.fullName,
          icon: this.imageMarker
        })

        marker.addListener('click', function () {
          infowindow.open(map, marker)
        })
        this.markers.push(marker)
      }.bind(this))
    }
  }
}
</script>
